import PurchaseOrders from "../../laboratory/purchaseOrders";

/**
 * Supply Hub of the frontdesk: browse the supplies, request them (a Purchase
 * Order approved by the Sr. MLS / Chief MLS) and follow the own requests.
 * The requests pages open the matching status tab of the Purchase Orders.
 */
export { default as BrowseSupplies } from "./browse";

const MyRequests = (initialTab) => () =>
  <PurchaseOrders mine initialTab={initialTab} title="My Supply Requests" />;

export const SubmittedRequests = MyRequests("pending");
export const ToReceiveRequests = MyRequests("approved");
export const CompletedRequests = MyRequests("received");
export const CancelledRequests = MyRequests("closed");
